export default __webpack_public_path__ + "static/media/close.dd908c88.svg";